import { createRoot } from "react-dom/client";
import type { SiteId } from "@dscg/memorandum-contracts";
import { SitePageApp, SITE_CONFIGS } from "@dscg/memorandum-ui";

function siteFromPath(): SiteId {
  const parts = window.location.pathname.split("/").filter(Boolean);
  const candidate = parts[0] === "sites" ? parts[1] : parts[0];
  return candidate && candidate in SITE_CONFIGS ? candidate as SiteId : "memorandum";
}

createRoot(document.getElementById("root")!).render(<SitePageApp siteId={siteFromPath()} />);
